export default __webpack_public_path__ + "static/side-nav-dont-5-abb4af3a16b87e062ba1e221d650e40c239f16f83e5109af82677d6c3e3cd4e3.png";